import React from 'react';
import { KanaInfo } from './data';
import { KanaCell } from './KanaCell';

interface KanaGroupProps {
    title: string;
    kanas: KanaInfo[];
    onKanaClick: (kana: KanaInfo) => void;
    selectedKana: KanaInfo | null;
    showRomaji: boolean;
    displayMode: 'both' | 'hiragana' | 'katakana';
    getCorrespondingKana: (kana: KanaInfo) => string;
    kanaRefs: React.MutableRefObject<Map<string, HTMLDivElement>>;
    filterType: 'seion' | 'dakuon' | 'yoon';
}

export const KanaGroup: React.FC<KanaGroupProps> = ({
    title,
    kanas,
    onKanaClick,
    selectedKana,
    showRomaji,
    displayMode,
    getCorrespondingKana,
    kanaRefs,
    filterType
}) => {
    // Filter kanas based on the active tab
    const seionKanas = kanas.filter(k => k.type === 'seion');
    const dakuonKanas = kanas.filter(k => k.type === 'dakuon');
    const handakuonKanas = kanas.filter(k => k.type === 'handakuon');
    const yoonKanas = kanas.filter(k => k.type === 'yoon');

    const renderKanaRow = (rowKanas: KanaInfo[], subtitle?: string) => {
        if (rowKanas.length === 0) return null;

        return (
            <div className="kana-subgroup">
                {subtitle && <div className="kana-subgroup-title">{subtitle}</div>}
                <div className={`gojuon-row ${filterType === 'yoon' ? 'yoon-grid' : ''}`}>
                    {rowKanas.map((kana) => (
                        <KanaCell
                            key={kana.kana}
                            ref={(el) => {
                                if (el) kanaRefs.current.set(kana.kana, el);
                            }}
                            kana={kana}
                            onClick={onKanaClick}
                            isSelected={selectedKana?.kana === kana.kana}
                            showRomaji={showRomaji}
                            correspondingKana={displayMode === 'both' ? getCorrespondingKana(kana) : undefined}
                        />
                    ))}
                </div>
            </div>
        );
    };

    // Determine what to render based on filterType
    const renderContent = () => {
        if (filterType === 'seion') {
            return renderKanaRow(seionKanas);
        } else if (filterType === 'dakuon') {
            return (
                <>
                    {renderKanaRow(dakuonKanas, dakuonKanas.length > 0 && handakuonKanas.length > 0 ? '浊音' : undefined)}
                    {renderKanaRow(handakuonKanas, dakuonKanas.length > 0 && handakuonKanas.length > 0 ? '半浊音' : undefined)}
                </>
            );
        } else {
            return renderKanaRow(yoonKanas);
        }
    };

    const content = renderContent();
    if (!content) return null;

    return (
        <div className="gojuon-group">
            <h3 className="gojuon-group-title">{title}</h3>
            {content}
        </div>
    );
};
